import { useEffect } from "react";

export type EventListenerProps<K extends keyof WindowEventMap> = {
  event: K;
  handler: (e: WindowEventMap[K]) => void;
};

export function EventListener<K extends keyof WindowEventMap>({
  event,
  handler,
}: EventListenerProps<K>) {
  useEffect(() => {
    window.addEventListener(event, handler);
    return () => window.removeEventListener(event, handler);
  }, []);

  return null;
}
